import { Hourglass } from "components/icons/generated";
import ListBox from "components/listBox/index";
import ListBoxInfoWrapper from "components/listBox/InfoWrapper";
import ListBoxItem from "components/listBox/Item";
import { VcsProvider } from "types/generated";
import { getCommitDigitsCount } from "utils/commit";
import Timestamp from "components/Timestamp";
import { AccessResult } from "utils/access";

type TaskElementProps = {
  id: string;
  canPerformAgain: AccessResult;
  command: string;
  commit: {
    hash: string;
    url: string;
  };
  createdAt: number;
  stackId: string;
  state: string;
  triggeredBy: string;
  provider: VcsProvider;
};

const TaskElement = (props: TaskElementProps) => {
  const { stackId, command, provider } = props;

  return (
    <ListBox
      headerLink={{
        name: command,
        to: `/stack/${stackId}/run/${props.id}`,
        routerLink: true,
        renderAsCode: true,
        canCopyName: true,
      }}
      performAgainErrorMessage={props.canPerformAgain.message}
      performAgain={props.canPerformAgain.result ? { stackId, command } : undefined}
      state={{ content: props.state, showTitle: true }}
    >
      <ListBoxInfoWrapper>
        <ListBoxItem icon={Hourglass}>
          Started on <Timestamp timestamp={props.createdAt} /> by {props.triggeredBy}
        </ListBoxItem>
        <ListBoxItem
          link={{
            url: props.commit.url,
            text: props.commit.hash.slice(0, getCommitDigitsCount(provider)),
          }}
        />
      </ListBoxInfoWrapper>
    </ListBox>
  );
};

export default TaskElement;
